module.exports = __webpack_public_path__ + "assets/stemIcon1.2524f252.svg";